document.addEventListener("DOMContentLoaded", function () {
  const markup_shadeSelectedIcon = () => {
    return `<span class="product-makeup-shadeSelected scale-95 h-full w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid place-items-center rounded-full border border-white pointer-events-none"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 text-white"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"></path></svg></span>`;
  };

  new Swiper(".product-makeup-variants", {
    spaceBetween: 6,
    slidesPerView: "auto",
    grabCursor: true,
    autoHeight: true,
    touchEventsTarget: "container",
    touchReleaseOnEdges: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".product-makeup-variants .nav_right_indicator",
      prevEl: ".product-makeup-variants .nav_left_indicator",
      disabledClass: "opacity-0 pointer-events-none",
    },
  });

  $(".product-makeup-shade").on("click", function () {
    if (CART) {
      const shadeSelectedIcon = markup_shadeSelectedIcon();
      const variantID = $(this).data("variant-id");

      $(".product-makeup-shadeSelected").remove();
      $(`.product-makeup-shade[data-variant-id="${variantID}"]`).append(
        shadeSelectedIcon,
      );

      $(
        `.product-makeup-shadeSelector option[data-variant-id="${variantID}"]`,
      ).prop("selected", true);
    }
  });

  $(".product-makeup-shadeSelector").on("change", function () {
    const variantID = $(this).find(":selected").data("variant-id");
    $(`.product-makeup-shade[data-variant-id="${variantID}"]`).trigger("click");
  });
});

